// @ts-check

/**
 * Rows for `PUT /garment-measurements` from one piece's grid (`{ [size]: { [field]: value } }`).
 * Inputs hold typed strings, so numbers are parsed here; empty or missing fields become null.
 * @param {string[]} sizes
 * @param {Record<string, Record<string, string | number>> | undefined} grid
 * @param {string[]} fieldKeys
 * @returns {Record<string, string | number | null>[]}
 */
export function buildMeasurementPayload(sizes, grid, fieldKeys) {
  return sizes.map((size) => ({
    size_name: size,
    ...Object.fromEntries(
      fieldKeys.map((key) => {
        const val = grid?.[size]?.[key];
        return [key, val === '' || val === undefined ? null : parseFloat(String(val))];
      }),
    ),
  }));
}
